/**
 * id {number, string} Column unique identificator
 * label {string} Column title
 * field_name {string} Column string identificator, used for slot reference
 * source_field {string}  Field name in the source data
 * showColumn {boolean} Enable the columns by default
 * alwaysVisible {boolean} Block making column visible / hidden
 * pinned {boolean} Pin the column
 * suppressSorting {boolead} Disable sorting
 * align {string} column alignment left/center/right
 */

export default [
  {
    id: 'user_name',
    label: 'Learner Name',
    field_name: 'userName',
    source_field: 'user_name',
    showColumn: true,
  },
  {
    id: 'email',
    label: 'Email',
    field_name: 'email',
    source_field: 'email',
    showColumn: true,
  },
  {
    id: 'feature_group',
    label: 'Feature Group',
    field_name: 'featureGroup',
    source_field: 'feature_group',
    showColumn: true,
  },
  {
    id: 'title',
    label: 'Lesson Title',
    field_name: 'title',
    source_field: 'title',
    showColumn: true,
  },
  {
    id: 'share_date',
    label: 'Share Date',
    field_name: 'shareDate',
    source_field: 'share_date',
    showColumn: true,
  },
  {
    id: 'status',
    label: 'Status',
    field_name: 'status',
    source_field: 'status',
    showColumn: true,
  },
  {
    id: 'cancel',
    label: '',
    field_name: 'cancel',
    source_field: 'cancel',
    showColumn: true,
    alwaysVisible: true,
    pinned: true,
    align: 'center',
  },
];
